import React from 'react'
import Navegador from '../components/Navegador'
import FormCotizar from '../components/FormCotizar'

class Financiamiento extends React.Component {
    render(){
        return(
            <React.Fragment>
                <Navegador/>
                <FormCotizar/>
            </React.Fragment>
        )
    }
}

export default Financiamiento